import qs from 'qs';
import request from '../../../../../shared/lib/request';
import { API } from '../../../../../shared/constants';


const getGruppi = () => request(
  {
    url: API.AGRUPPO_AGENZIA_KIRON,
    method: 'GET',
  });

const getGruppiByAgenzia = (agenziaId) => request(
  {
    url: API.GRUPPO_AGENZIA_KIRON,
    method: 'GET',
    params: {
      filter: [{
        type: 'eq',
        field: 'agenzia',
        value: agenziaId || null,
      },
      // {
      //   type: 'isnull',
      //   field: 'profiloSenior',
      // },
      ],
    },
    paramsSerializer: (params) => qs.stringify(params),
  });

const getGruppiOptions = (agenziaId) => getGruppiByAgenzia(agenziaId).then(
    (res) => res._embedded.gruppoagenziakiron.map((obj)=>{ return {value: obj.id, label: obj.nominativo ? obj.nominativo : obj.nome }}) // eslint-disable-line
  ).then((data) => data);

const getGruppiWithoutSeniorOptions = (agenziaId) => getGruppiByAgenzia(agenziaId).then(
    (res) => res._embedded.gruppoagenziakiron.map((obj)=>{ return {value: obj.id, label: obj.nominativo ? obj.nominativo : obj.nome, disabled: obj.profiloSenior ? true: false }}) // eslint-disable-line
  ).then((data) => data);


const GruppoAgenziaKironService = {
  getGruppi,
  getGruppiOptions,
  getGruppiByAgenzia,
  getGruppiWithoutSeniorOptions,
};

export default GruppoAgenziaKironService;



// WEBPACK FOOTER //
// ./app/shared/services/api/agenziakiron/gruppo/index.js